"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartTooltipXAxisMarker = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../../../utils");
var TOOLTIP_LINE_EXTENSION = 10;
exports.ChartTooltipXAxisMarker = react_1.forwardRef(function (_a, ref) {
    var chartHeight = _a.chartHeight;
    return (react_1.default.createElement("rect", { ref: ref, fill: utils_1.theme.colors.NTDarkGrey[900], height: 22, opacity: 0, y: chartHeight + TOOLTIP_LINE_EXTENSION, "data-test-component-name": "chart-tooltip-x-axis-marker" }));
});
